// extracted by css-extract-rspack-plugin
export default {"sceneContainer":"MdwbL4","sceneBg":"taMdAa","main":"jW9v2D","video":"jwNU58","leftButton":"lbHrEb","rightButton":"_we1J_"};